export default class DelayLoader {
    // Some nice duplication we got here; destructure with default values,
    // and if nothing is passed in we default to the second object.
    // Prevents errors when simply calling new DelayLoader();
    constructor({ loading = false, delay = 400 } = { loading: false, delay: 400 }) {
        this.processing = loading;
        this.loading = loading;
        this.delay = delay;
    }

    start() {
        this.processing = true;

        this.timeout = setTimeout(() => {
            this.loading = true;
        }, this.delay);
    }

    reset() {
        clearTimeout(this.timeout);

        this.loading = false;
        this.processing = false;
    }

    get isLoading() {
        return this.loading;
    }

    get isProcessing() {
        return this.processing;
    }
}
